import React from "react";
import { Cake } from "lucide-react";

const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const DAYS_IN = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const pad = (n) => String(n).padStart(2, "0");

// "MM-DD" birthday (no year). Mochi wears the party hat on this day every
// year and the hat unlocks for keeps on the first one.
export default function BirthdayPicker({ value, onSave, hatUnlocked }) {
    const [month, setMonth] = React.useState(value ? Number(value.slice(0, 2)) : 0);
    const [day, setDay] = React.useState(value ? Number(value.slice(3, 5)) : 0);
    React.useEffect(() => {
        setMonth(value ? Number(value.slice(0, 2)) : 0);
        setDay(value ? Number(value.slice(3, 5)) : 0);
    }, [value]);

    const maxDay = month ? DAYS_IN[month - 1] : 31;
    const next = month && day ? `${pad(month)}-${pad(Math.min(day, maxDay))}` : "";
    const dirty = next !== (value || "");
    const label = value ? `${MONTHS[Number(value.slice(0, 2)) - 1]} ${Number(value.slice(3, 5))}` : null;

    const selectCls = "bg-cream rounded-xl px-2 py-1.5 font-body text-xs text-warm-900 outline-none border-2 border-transparent focus:border-terracotta";

    return (
        <div className="mt-3 rounded-2xl bg-cream/90 px-3 py-2.5" data-testid="birthday-picker">
            <div className="flex items-center gap-3">
                <Cake size={18} className="text-terracotta shrink-0" />
                <div className="flex-1 min-w-0">
                    <p className="font-display text-sm text-warm-900 leading-tight">Your birthday</p>
                    <p className="font-body text-[11px] text-warm-500 mt-0.5" data-testid="birthday-status">
                        {label
                            ? `${label} — mochi wears the party hat for you that day 🎂${hatUnlocked ? "" : " (and keeps it after)"}`
                            : "tell mochi when it is — she'll wear the party hat for you 🎂"}
                    </p>
                </div>
            </div>
            <div className="mt-2 flex items-center gap-2">
                <select value={month} onChange={(e) => setMonth(Number(e.target.value))} className={selectCls} aria-label="Birthday month" data-testid="birthday-month-select">
                    <option value={0}>month</option>
                    {MONTHS.map((m, i) => <option key={m} value={i + 1}>{m}</option>)}
                </select>
                <select value={day} onChange={(e) => setDay(Number(e.target.value))} className={selectCls} aria-label="Birthday day" data-testid="birthday-day-select">
                    <option value={0}>day</option>
                    {Array.from({ length: maxDay }, (_, i) => i + 1).map((d) => <option key={d} value={d}>{d}</option>)}
                </select>
                {dirty && next && (
                    <button type="button" onClick={() => onSave(next)}
                        className="ml-auto rounded-full bg-terracotta text-cream font-display text-xs px-3 py-1.5"
                        data-testid="birthday-save-btn">
                        save
                    </button>
                )}
                {value && !dirty && (
                    <button type="button" onClick={() => onSave("")}
                        className="ml-auto font-body text-[11px] text-warm-500 hover:text-warm-900"
                        data-testid="birthday-clear-btn">
                        clear
                    </button>
                )}
            </div>
        </div>
    );
}
